import * as svg from "../../../assets/lock.svg";

import {iconBuilder} from "./iconBuilder";

export const SeamLogoIcon = iconBuilder(svg, "SeamLogoIcon", "0 0 61 56");
